<template>
  <div>
    <div class="main-content">
      <div class="row">
        <div class="col-md-12">
          <div class="card">
            <div class="card-header">
              <div class="card-title">Status de Chamado: </div>
            </div>
            <hr style="margin-top: -4px" />
            <div class="col-md-12">
              <form action>
                <div class="form-row">
                  <div class="form-group col-md-12">
                    <label for="Name">
                      <span class="required">*</span> Descrição:
                    </label>
                    <input autocomplete="new-password" type="text" id="Name" class="form-control"
                      v-model="status_call.description" placeholder="" />
                  </div>
                  <div class="form-group col-md-12">
                    <label for="Color">
                      <span class="required">*</span> Cor:
                    </label>
                    <select id="Color" class="form-control" v-model="status_call.badge_description">
                      <option value="badge-primary" class="badge badge-primary">Primary</option>
                      <option value="badge-secondary" class="badge badge-secondary">Secondary</option>
                      <option value="badge-success" class="badge badge-success">Success</option>
                      <option value="badge-danger" class="badge badge-danger">Danger</option>
                      <option value="badge-warning" class="badge badge-warning">Warning</option>
                      <option value="badge-info" class="badge badge-info">Info</option>
                      <option value="badge-light" class="badge badge-light" style="color: #000;">Light</option>
                      <option value="badge-dark" class="badge badge-dark">Dark</option>
                    </select>
                  </div>
                  <!-- <div class="form-group col-md-12">
                    <label for="Name">
                      <span class="required">*</span> Próxima cor:
                    </label>
                    <input
                      autocomplete="new-password"
                      type="color"
                      id="Name"
                      class="form-control"
                      v-model="status_call.badge_description_next"
                      placeholder=""
                    />
                  </div> -->
                </div>
                <span class="required_fields">
                  <span class="required">*</span>
                  <strong>Campos obrigatórios</strong>
                </span>
                <div class="block text-right mb-1">
                  <router-link to="/statusCall" class="btn btn-back">
                    <i class="fa fa-arrow-left"></i> Voltar
                  </router-link>
                  <a class="btn btn-add ml-1" @click="save">
                    Salvar
                    <i class="fa fa-save"></i>
                  </a>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import BaseCrud from "../../layouts/Base/BaseCrud";
import vSelect from "vue-select";

export default {
  name: "imageUpload",
  data() {
    return {
      status_call: {
        description: "",
        badge_description: "",
      },
    };
  },
  computed: {},
  methods: {
    save: function () {
      const self = this;
      let api = self.$store.state.api + "statusCall";

      if (self.status_call.id) {
        api += "/" + self.status_call.id;
        self.status_call._method = "PUT";
      }

      axios
        .post(api, self.status_call)
        .then((response) => {
          self.$message(
            "Sucesso",
            `Informações guardadas com sucesso`,
            "success"
          );
          this.$router.push("/statusCall");
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
    getStatusCall: function (id) {
      const self = this;
      const api = self.$store.state.api + "statusCall/" + id;

      axios
        .get(api)
        .then((response) => {
          self.status_call = response.data.data[0];
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
  },
  mounted: function () {
    const self = this;
    let id = self.$route.params.id;

    if (id) {
      self.getStatusCall(id);
    }
  },
  components: {
    BaseCrud,
    vSelect,
  },
};
</script>
<style scoped>
.profile_user {
  text-align: center;
}

.photo {
  display: block;
  margin-left: 5px;
  width: 18%;
  border-radius: 10px;
  max-width: 400px;
  max-height: 400px;
  object-fit: cover;
}

.btn-user:hover,
.btn-user[aria-expanded="true"] {
  background: linear-gradient(to right, #000, #666);
  color: #fff !important;
}

.photo-title {
  color: #000;
  font-size: 18px;
  display: block;
  margin-left: 5px;
  width: 18%;
}

.styled-select option {
  display: flex;
  align-items: center;
}

.badge-option::before {
  content: "";
  display: inline-block;
  width: 15px;
  height: 15px;
  margin-right: 10px;
  border-radius: 3px;
  border: 1px solid #ccc;
}

.badge-option[value="badge-primary"]::before {
  background-color: #007bff;
}

.badge-option[value="badge-secondary"]::before {
  background-color: #6c757d;
}

.badge-option[value="badge-success"]::before {
  background-color: #28a745;
}

.badge-option[value="badge-danger"]::before {
  background-color: #dc3545;
}

.badge-option[value="badge-warning"]::before {
  background-color: #ffc107;
}

.badge-option[value="badge-info"]::before {
  background-color: #17a2b8;
}

.badge-option[value="badge-light"]::before {
  background-color: #f8f9fa;
  border: 1px solid #ccc;
}

.badge-option[value="badge-dark"]::before {
  background-color: #343a40;
}
</style>